<template>
    <div>
        <v-form ref="formObservacao" v-model="valido" class="mt-3" @submit.prevent="Adicionar">
            <v-textarea v-model="observacao" label="Nova observação" rows="2" outlined dense/>
            <div class="d-flex justify-end mb-3">
                <v-btn text color="primary" :loading="carregando" @click="Atualizar"><v-icon left>mdi-refresh</v-icon>Atualizar</v-btn>
                <v-btn color="primary" :loading="salvando" :disabled="!observacao.trim()" @click="Adicionar">Registrar observação</v-btn>
            </div>
        </v-form>
        <v-alert v-if="erro" type="error" text>{{ erro }}</v-alert>
        <v-progress-linear v-if="carregando" indeterminate color="primary"/>
        <v-list v-if="eventos.length" two-line>
            <template v-for="(evento, index) in eventosOrdenados">
                <v-list-item :key="'evento-' + evento.id">
                    <v-list-item-icon><v-icon :color="evento.automatico ? 'primary' : undefined">{{ evento.automatico ? 'mdi-history' : 'mdi-comment-text-outline' }}</v-icon></v-list-item-icon>
                    <v-list-item-content>
                        <v-list-item-title>{{ DataHora(evento.dataHora) }} · {{ evento.usuarioNome }}</v-list-item-title>
                        <div class="text-caption mb-1">{{ evento.tipo }}</div>
                        <div class="descricao-historico">{{ evento.descricao }}</div>
                    </v-list-item-content>
                </v-list-item>
                <v-divider v-if="index < eventos.length - 1" :key="'divisor-' + evento.id"/>
            </template>
        </v-list>
        <p v-else-if="!carregando" class="text--secondary mt-3">Nenhum registro de relacionamento.</p>
    </div>
</template>
<script>
import OportunidadeService from '../../../core/services/doacao/OportunidadeService';

export default {
    props: { oportunidadeId: { type: Number, required: true } },
    data: () => ({ service: new OportunidadeService(), eventos: [], observacao: '', carregando: false, salvando: false, erro: '', valido: true, requisicao: 0 }),
    computed: {
        eventosOrdenados() { return this.eventos.slice().sort((a, b) => (a.dataHora || '').localeCompare(b.dataHora || '') || a.id - b.id); }
    },
    watch: {
        oportunidadeId() { this.eventos = []; this.observacao = ''; this.Atualizar(); }
    },
    created() { this.Atualizar(); },
    beforeDestroy() { this.requisicao++; },
    methods: {
        async Atualizar() {
            const requisicao = ++this.requisicao;
            if (!this.oportunidadeId) return;
            this.carregando = true;
            this.erro = '';
            try { const res = await this.service.Historico(this.oportunidadeId); if (requisicao === this.requisicao) this.eventos = res.data || []; }
            catch (err) { if (requisicao === this.requisicao) this.erro = this.Mensagem(err); }
            finally { if (requisicao === this.requisicao) this.carregando = false; }
        },
        async Adicionar() {
            if (!this.observacao.trim() || this.salvando) return;
            const oportunidadeId = this.oportunidadeId;
            this.salvando = true;
            this.erro = '';
            try {
                await this.service.AdicionarObservacao(oportunidadeId, this.observacao.trim());
                if (oportunidadeId === this.oportunidadeId) { this.observacao = ''; await this.Atualizar(); this.$emit('atualizado'); }
            } catch (err) { this.erro = this.Mensagem(err); }
            finally { this.salvando = false; }
        },
        DataHora(valor) { return valor ? new Date(valor).toLocaleString('pt-BR') : ''; },
        Mensagem(err) { const data = err.response && err.response.data; return typeof data === 'string' ? data : (data && (data.detail || data.title)) || 'Não foi possível carregar o histórico.'; }
    }
};
</script>
<style scoped>
.descricao-historico { white-space: pre-wrap; overflow-wrap: anywhere; }
</style>
